import { WeddingPartyList } from '@apps/guest/packages/layout-engine/widgets/WeddingPartyList';
import { GuestSiteComponentProps } from '@apps/websiteCustomJsonComponents/types';
import { Box } from '@withjoy/joykit';
import React from 'react';

export type VipData = Readonly<{
  headingText?: string;
  sortOrder?: string[];
  exclusiveFilterIDs?: string[];
}>;

export const VipGuest = (props: GuestSiteComponentProps) => {
  const data = props.data.content as VipData;

  return (
    <Box width="100%">
      <WeddingPartyList
        graphicAccent={undefined}
        eventId={props.data.eventId}
        presentationSettings={{ sortOrder: data.sortOrder, excludedIDs: data.exclusiveFilterIDs }}
      />
    </Box>
  );
};
